module.exports = __webpack_public_path__ + "static/media/closeLightGray.38ca5076.svg";